const youtubeStreamFieldsStyles = () => ({
  fieldSpacing: { marginBottom: 10, marginTop: 10 },
  // Segmented destination switcher (YouTube channel / Stream key URI), shown only when the
  // org has a linked YouTube account. Mirrors the design's pill tabs.
  destTabs: {
    display: 'flex',
    gap: 4,
    background: '#F2F1EE',
    borderRadius: 9,
    padding: 4,
    marginBottom: 14,
  },
  destTab: {
    // 1 1 0 + minWidth:0 so both tabs are exactly half regardless of label length
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
    padding: '9px 10px',
    borderRadius: 6,
    cursor: 'pointer',
    userSelect: 'none',
    background: 'transparent',
    boxShadow: 'none',
    color: '#8A8A8A',
    fontSize: 13,
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  destTabActive: {
    background: '#fff',
    boxShadow: '0 1px 3px rgba(0,0,0,.12)',
    color: '#E06E5C',
  },
  destTabIcon: {
    fontSize: 19,
  },
  ytFields: {
    display: 'flex',
    flexDirection: 'column',
    gap: 11,
  },
  ytTitleRow: {
    display: 'flex',
    // stretch so the thumbnail box matches the title field's height
    alignItems: 'stretch',
    gap: 13,
  },
  // Compact thumbnail button sitting to the left of the video title (design: grey box with a
  // white add-photo icon). Height stretches to the title field; a picked image fills the box.
  compactThumbnail: {
    width: 52,
    minWidth: 52,
    flex: 'none',
    backgroundColor: '#8C8C8C',
    borderRadius: 6,
    color: '#fff',
    overflow: 'hidden',
  },
  // Shown in place of the destination switcher when the org's YouTube link is dead, so the
  // missing YouTube tab reads as a broken connection rather than as a channel never linked.
  reconnectAlert: {
    marginBottom: 14,
    fontSize: 13,
  },
  errorContainer: {
    marginBottom: 15,
  },
  error: {
    fontSize: '12px',
    color: 'red',
  },
})

export default youtubeStreamFieldsStyles
